// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-closed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-p1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-p2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-p3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-blue-p1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-blue-p2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../bot-icons/src/assets/icons/icon-audio-blue-p3.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-default-HhzU7u {
  background-repeat: no-repeat;
  background-size: cover;
  width: 14px;
  height: 14px;
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__mask-attribute-nhtijN {
  -webkit-mask-size: 100%;
  mask-size: 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-default-_hADdL {
  background-color: #7a7b7c;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-default-tSH92W {
  background-color: #000;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 / 100% no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 / 100% no-repeat;
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-playing-ey7y9G {
  background-color: #000;
  animation: 1.5s infinite \\------packages-components-bot-semi-src-components-ui-audio-index-module__icons-black-vAkl7k;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 / 100% no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 / 100% no-repeat;
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-playing-tXTavC {
  background-color: #4d53e8;
  animation: 1.5s infinite \\------packages-components-bot-semi-src-components-ui-audio-index-module__icons-black-vAkl7k;
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-blue-default-E3ivjT {
  background-color: #4d53e8;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-blue-playing-vIOGiJ {
  background-color: #4d53e8;
  animation: 1.5s infinite \\------packages-components-bot-semi-src-components-ui-audio-index-module__icons-blue-RvNPAj;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-closed-L9pUva {
  background-color: #000;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 0 0 / 100% no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 0 0 / 100% no-repeat;
}

.\\------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-closed-glGmgd {
  background-color: #7a7b7c;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@keyframes \\------packages-components-bot-semi-src-components-ui-audio-index-module__icons-black-vAkl7k {
  0% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 0 / 100% no-repeat;
  }

  33% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 0 0 / 100% no-repeat;
  }

  66% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) 0 0 / 100% no-repeat;
  }

  100% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 0 / 100% no-repeat;
  }
}

@keyframes \\------packages-components-bot-semi-src-components-ui-audio-index-module__icons-blue-RvNPAj {
  0% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) 0 0 / 100% no-repeat;
  }

  33% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) 0 0 / 100% no-repeat;
  }

  66% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) 0 0 / 100% no-repeat;
  }

  100% {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) 0 0 / 100% no-repeat;
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) 0 0 / 100% no-repeat;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-default": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-default-HhzU7u`,
	"iconDefault": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-default-HhzU7u`,
	"mask-attribute": `------packages-components-bot-semi-src-components-ui-audio-index-module__mask-attribute-nhtijN`,
	"maskAttribute": `------packages-components-bot-semi-src-components-ui-audio-index-module__mask-attribute-nhtijN`,
	"icon-grey-default": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-default-_hADdL`,
	"iconGreyDefault": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-default-_hADdL`,
	"icon-black-default": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-default-tSH92W`,
	"iconBlackDefault": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-default-tSH92W`,
	"icon-black-playing": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-playing-ey7y9G`,
	"iconBlackPlaying": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-playing-ey7y9G`,
	"icons-black": `------packages-components-bot-semi-src-components-ui-audio-index-module__icons-black-vAkl7k`,
	"iconsBlack": `------packages-components-bot-semi-src-components-ui-audio-index-module__icons-black-vAkl7k`,
	"icon-grey-playing": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-playing-tXTavC`,
	"iconGreyPlaying": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-playing-tXTavC`,
	"icon-blue-default": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-blue-default-E3ivjT`,
	"iconBlueDefault": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-blue-default-E3ivjT`,
	"icon-blue-playing": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-blue-playing-vIOGiJ`,
	"iconBluePlaying": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-blue-playing-vIOGiJ`,
	"icons-blue": `------packages-components-bot-semi-src-components-ui-audio-index-module__icons-blue-RvNPAj`,
	"iconsBlue": `------packages-components-bot-semi-src-components-ui-audio-index-module__icons-blue-RvNPAj`,
	"icon-black-closed": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-closed-L9pUva`,
	"iconBlackClosed": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-black-closed-L9pUva`,
	"icon-grey-closed": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-closed-glGmgd`,
	"iconGreyClosed": `------packages-components-bot-semi-src-components-ui-audio-index-module__icon-grey-closed-glGmgd`
};
export default ___CSS_LOADER_EXPORT___;
